/**
 * 按需加载外部脚本。
 *
 * index.html 里曾用 <script> 直接引入 jsmediatags（同步阻塞）和 OpenCV.js（约 9MB），
 * 两者都只在特定子功能里用到，却拖累了全站首屏。改为用到时再注入。
 */

const pendingScripts = new Map()

function injectScript(src, timeoutMs) {
  return new Promise((resolve, reject) => {
    const script = document.createElement('script')
    script.src = src
    script.async = true

    const timer = setTimeout(() => {
      cleanup()
      script.remove()
      reject(new Error(`脚本加载超时: ${src}`))
    }, timeoutMs)

    function cleanup() {
      clearTimeout(timer)
      script.onload = null
      script.onerror = null
    }

    script.onload = () => {
      cleanup()
      resolve()
    }
    script.onerror = () => {
      cleanup()
      script.remove()
      reject(new Error(`脚本加载失败: ${src}`))
    }

    document.head.appendChild(script)
  })
}

function loadScriptOnce(src, timeoutMs) {
  const cached = pendingScripts.get(src)
  if (cached) return cached

  const promise = injectScript(src, timeoutMs).catch((error) => {
    // 失败后允许下次重试
    pendingScripts.delete(src)
    throw error
  })
  pendingScripts.set(src, promise)
  return promise
}

const JS_MEDIATAGS_URL = 'https://cdn.jsdelivr.net/npm/jsmediatags@3.9.7/dist/jsmediatags.min.js'

/** 按需加载 jsmediatags，返回是否可用（失败不抛错） */
export function loadJsmediatags() {
  if (window.jsmediatags) return Promise.resolve(true)
  return loadScriptOnce(JS_MEDIATAGS_URL, 15000)
    .then(() => Boolean(window.jsmediatags))
    .catch(() => false)
}
